/* ============================================================
   TapForce Rediseño v1 — tapforce-r.js
   JS de la maqueta, adaptado:
   - SÍ: patrón QR decorativo, ruleta demo, reveal on scroll.
   - NO: nav móvil (se usa el header del tema) ni generador demo de
     campos por dispositivo (el real vive en tapforce-featured-product).
   Todo defensivo (null-checks) y encapsulado en IIFE: no toca globals
   ni interfiere con el setInterval del featured product ni con WideBundle.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    /* ---- Patrón QR decorativo (todos los .tf-qr dentro de .tf-r) ---- */
    try {
      var pat = '1111111 1000001 1011101 1011101 1011101 1000001 1111111 0000000 1101011 1011010 0110101 1010011 1101100 0011011 1110101'.replace(/\s/g, '');
      var qrs = document.querySelectorAll('.tf-r .tf-qr');
      qrs.forEach(function (qr) {
        if (qr.childElementCount > 0) return; /* ya generado (p.ej. re-render del editor) */
        for (var i = 0; i < 49; i++) {
          var b = document.createElement('i');
          if (pat[i] === '0') b.className = 'o';
          qr.appendChild(b);
        }
      });
    } catch (e) { /* decorativo: nunca romper la página */ }

    /* ---- Ruleta demo ---- */
    var wheel = document.getElementById('tf-r-wheel');
    var spinBtn = document.getElementById('tf-r-spin');
    var prize = document.getElementById('tf-r-prize');
    if (wheel && spinBtn && prize) {
      var rot = 0;
      var spinning = false;
      var prizes = ['🎉 ¡Café gratis!', '✨ 10% de descuento', '🍰 Postre gratis', '🥂 Chupito invitado', '🎁 2x1 en bebida', '🔁 ¡Sigue participando!'];
      spinBtn.addEventListener('click', function () {
        if (spinning) return;
        spinning = true;
        prize.textContent = '';
        var seg = Math.floor(Math.random() * 6);
        rot += 360 * 5 + (360 - (seg * 60) - 30);
        wheel.style.transform = 'rotate(' + rot + 'deg)';
        setTimeout(function () {
          prize.textContent = prizes[seg];
          spinning = false;
        }, 4300);
      });
    }

    /* ---- Reveal on scroll (solo elementos dentro de .tf-r) ---- */
    var reduced = false;
    try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    var revealEls = document.querySelectorAll('.tf-r [data-reveal]');
    if (revealEls.length) {
      if (!reduced && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12 });
        revealEls.forEach(function (el) { io.observe(el); });
      } else {
        /* Sin IO o con reduced motion: mostrar todo directamente */
        revealEls.forEach(function (el) { el.classList.add('is-in'); });
      }
    }

    /* ---- Scroll suave en anclas del rediseño (scoped a .tf-r) ---- */
    if (!reduced) {
      document.querySelectorAll('.tf-r a[href^="#"]').forEach(function (a) {
        a.addEventListener('click', function (ev) {
          var id = a.getAttribute('href').slice(1);
          if (!id) return;
          var target = document.getElementById(id);
          if (!target) return;
          ev.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          try { history.replaceState(null, '', '#' + id); } catch (e) {}
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
